var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDangerLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8685 0.999956L21.3945 17.5C21.4823 17.652 21.5285 17.8244 21.5285 18C21.5285 18.1755 21.4823 18.3479 21.3945 18.4999C21.3068 18.652 21.1805 18.7782 21.0285 18.866C20.8765 18.9537 20.7041 19 20.5285 19H1.47654C1.301 19 1.12856 18.9537 0.976546 18.866C0.82453 18.7782 0.698296 18.652 0.610531 18.4999C0.522765 18.3479 0.476561 18.1755 0.476563 18C0.476564 17.8244 0.52277 17.652 0.610537 17.5L10.1365 0.999956C10.2243 0.847949 10.3505 0.721722 10.5026 0.633962C10.6546 0.546202 10.827 0.5 11.0025 0.5C11.1781 0.5 11.3505 0.546202 11.5025 0.633962C11.6545 0.721722 11.7808 0.847949 11.8685 0.999956ZM3.20854 17H18.7965L11.0025 3.49996L3.20854 17ZM10.0025 14H12.0025V16H10.0025V14ZM10.0025 6.99996H12.0025V12H10.0025V6.99996Z",
    fill: "#F34E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerLive);
export default __webpack_public_path__ + "static/media/danger-live.3bc181278cf10b73626f6d284df199f3.svg";
export { ForwardRef as ReactComponent };